import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const Salary_Deduction = ({ pdfExportComponent, data, company, company2 }) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`หนังสือยินยอมให้หักเงิน - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="header"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "123px",
                  right: "47px",
                  fontSize: "20px",
                  width: "705px",
                  // fontFamily: "angsaBold",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <u>
                  <b className="docs-font">หนังสือยินยอมให้หักเงิน</b>
                </u>
              </div>

              <div
                className="docs-font"
                id="date"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "200px",
                  right: "74px",
                  fontSize: "20px",
                  // fontFamily: "angsaLight",
                  width: "310px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                  // backgroundColor: "red"
                }}
              >
                ทำที่....................................................................................
                <br />
                วันที่..................เดือน.................................พ.ศ..................
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "284px",
                  right: "71px",
                  fontSize: "20px",
                  // fontFamily: "angsaLight",
                  width: "683px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                }}
              >
                &nbsp;&emsp;&emsp;ข้าพเจ้า.....................................................................................................................................................อายุ..................ปี
                พนักงานบริษัท...........................................................(“บริษัทฯ”)<br />
                แผนก/ฝ่าย................................................................................................................................
                ขอทำหนังสือฉบับนี้ให้ไว้กับบริษัทฯ
                เพื่อเป็นการยินยอมว่าหากข้าพเจ้า ได้กระทำให้เกิดความเสียหาย
                หรือสูญหาย หรือ บุบสลาย ซึ่งทรัพย์สิน หรือสินค้าของบริษัทฯ
                ไม่ว่าจะเป็นโดยทั้งหมดหรือแต่บางส่วน
                ข้าพเจ้าตกลงชดใช้ค่าเสียหายให้แก่บริษัทฯ
                โดยยินยอมให้บริษัทฯหักเงินค่าเสียหายดังกล่าวจากค่าจ้าง
                เบี้ยเลี้ยง &nbsp;&nbsp;โบนัส
                &nbsp;&nbsp;ค่าตอบแทนอื่นใด&nbsp;&nbsp;&nbsp; ( ถ้ามี
                )&nbsp;&nbsp; ที่ข้าพเจ้ามีสิทธิได้รับ จากบริษัทฯ
                นำมาชำระหนี้ค่าเสียหายได้ทั้งหมด
                <br />
                <p />
                &nbsp;&emsp;&emsp;ข้าพเจ้าได้อ่านและรับทราบข้อความตามหนังสือฉบับนี้โดยตลอดแล้ว
                เห็นว่าถูกต้องตรงตามเจตนาของข้าพเจ้าทุกประการ
                เพื่อเป็นหลักฐานจึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "610px",
                  right: "71px",
                  fontSize: "20px",
                  // fontFamily: "angsaLight",
                  width: "683px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  lineHeight: "27px",
                }}
              >
                &nbsp;&nbsp;&nbsp;ลงชื่อ....................................................................................ลูกจ้าง
                <br />
                (...................................................................................)
                <br />
                <br />
                <p />
                &nbsp;&nbsp;&nbsp;ลงชื่อ...................................................................................พยาน
                <br />
                (...................................................................................)
                <br />
                <br />
                <p />
                &nbsp;&nbsp;&nbsp;ลงชื่อ...................................................................................พยาน
                <br />
                (...................................................................................)
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "197px",
                  right: "79px",
                  fontSize: "20px",
                  width: "279px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.write_at || `บริษัท ${company.name_th}`}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "298px",
                  fontSize: "20px",
                  width: "62px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_day}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "159px",
                  fontSize: "20px",
                  width: "112px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_month}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "75px",
                  fontSize: "20px",
                  width: "64px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "281px",
                  right: "165px",
                  fontSize: "20px",
                  width: "499px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "281px",
                  right: "82px",
                  fontSize: "20px",
                  width: "55px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_age}
              </div>

              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "308px",
                  right: "477px",
                  fontSize: "20px",
                  width: "195px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.write_at || `บริษัท ${company.name_th}`}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "334px",
                  right:data.detail_department?.length > 40 ? "294px" : "322px",
                  fontSize: "20px",
                  width: "254px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data?.detail_department?.split("_")[1] ||
                  data?.detail_department?.split("_")[0]}
              </div>

              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "633px",
                  right: "274px",
                  fontSize: "20px",
                  width: "276px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

Salary_Deduction.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default Salary_Deduction;
